// @ts-ignore
importScripts('https://static.parastorage.com/unpkg/lodash@4.17.15/lodash.min.js')
require('thunderbolt-platform/src/client/clientWorker')
